var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("history-list", {
    attrs: {
      "import-template": _vm.importTemplate,
      id: _vm.id,
      history: true
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };